import { render, staticRenderFns } from "./ContributionPlannerLearnMore.vue?vue&type=template&id=6bd28d4d&scoped=true"
import script from "./ContributionPlannerLearnMore.vue?vue&type=script&lang=ts"
export * from "./ContributionPlannerLearnMore.vue?vue&type=script&lang=ts"
import style0 from "./ContributionPlannerLearnMore.vue?vue&type=style&index=0&id=6bd28d4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd28d4d",
  null
  
)

export default component.exports